/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Hide unavailable color/size swatches for US shoppers only.
(function () {
  var COLOR_OPTION_NAMES = [
    "color",
    "vixen color",
    "kathy color",
    "colour",
    "couleur",
    "spalva",
    "farbe",
    "cor"
  ];

  function isUSCustomer() {
    var body = document.body;
    if (!body) return false;
    return String(body.getAttribute("data-location") || "").toUpperCase() === "US";
  }
  function isEnableStock() {
    var body =document.body;
    if(!body) return false;
    return String(body.getAttribute("data-stock") || "") === "true"
  }
  function getOptionIndexByNames(product, names) {
    if (!product || !Array.isArray(product.options)) return -1;
    var normalizedNames = names.map(function (name) {
      return String(name).toLowerCase();
    });

    for (var i = 0; i < product.options.length; i++) {
      var optionName = String(product.options[i] || "").toLowerCase();
      if (normalizedNames.indexOf(optionName) !== -1) return i;
    }
    return -1;
  }

  function getOptionIndexContaining(product, word) {
    if (!product || !Array.isArray(product.options)) return -1;
    var normalizedWord = String(word).toLowerCase();
    for (var i = 0; i < product.options.length; i++) {
      var optionName = String(product.options[i] || "").toLowerCase();
      if (optionName.indexOf(normalizedWord) !== -1) return i;
    }
    return -1;
  }

  function setSwatchHidden(item, shouldHide) {
    if (!item) return;
    item.style.display = shouldHide ? "none" : "";
  }

  function getSwatchInputValue(item) {
    if (!item) return "";
    var input = item.querySelector("input[type='radio']");
    return input ? String(input.value || "") : "";
  }

  function getFirstVisibleSwatchInput(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].style.display === "none") continue;
      var input = items[i].querySelector("input[type='radio']");
      if (input) return input;
    }
    return null;
  }

  function hasSellableStock(variant) {
    if (!variant) return false;

    // For US we hide swatches when inventory is 0,
    // even if inventory policy allows continue selling.
    if (typeof variant.inventory_quantity === "number") {
      return variant.inventory_quantity > 0;
    }

    return !!variant.available;
  }

  function applyUSSwatchVisibility(product, variant, sectionClass) {
    if (!isUSCustomer()) return;    
    if (isEnableStock()) return;

    if (!product || !Array.isArray(product.variants)) return;

    var colorIndex = getOptionIndexByNames(product, COLOR_OPTION_NAMES);
    var sizeIndex = getOptionIndexContaining(product, "size");

    if (colorIndex === -1 || sizeIndex === -1) return;

    var sectionRoot = sectionClass ? document.querySelector(sectionClass) : document;
    if (!sectionRoot) return;

    var productForm = sectionRoot.querySelector(".js-product-form");
    if (!productForm) return;

    var colorPosition = colorIndex + 1;
    var sizePosition = sizeIndex + 1;

    var colorWrap = productForm.querySelector(".js-product-form-swatch[data-option-index='" + colorPosition + "']");
    var sizeWrap = productForm.querySelector(".js-product-form-swatch[data-option-index='" + sizePosition + "']");
    if (!colorWrap || !sizeWrap) return;

    var colorItems = colorWrap.querySelectorAll(".product-form__swatch__item");
    var sizeItems = sizeWrap.querySelectorAll(".product-form__swatch__item");

    // 1) Hide colors that have no available sizes.
    for (var i = 0; i < colorItems.length; i++) {
      var colorValue = getSwatchInputValue(colorItems[i]);
      var hasAvailableSizes = product.variants.some(function (v) {
        return hasSellableStock(v) && v.options[colorIndex] === colorValue;
      });
      setSwatchHidden(colorItems[i], !hasAvailableSizes);
    }

    var checkedColorInput = colorWrap.querySelector("input[type='radio']:checked");
    var checkedColorItem = checkedColorInput ? checkedColorInput.closest(".product-form__swatch__item") : null;

    if (checkedColorItem && checkedColorItem.style.display === "none") {
      var fallbackColorInput = getFirstVisibleSwatchInput(colorItems);
      if (fallbackColorInput && !fallbackColorInput.checked) {
        fallbackColorInput.checked = true;
        fallbackColorInput.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }
    }

    var selectedColor = checkedColorInput ? checkedColorInput.value : "";
    if (!selectedColor && variant && Array.isArray(variant.options)) {
      selectedColor = variant.options[colorIndex] || "";
    }
    if (!selectedColor) return;

    // 2) For selected color, show only available sizes.
    for (var s = 0; s < sizeItems.length; s++) {
      var sizeValue = getSwatchInputValue(sizeItems[s]);
      var isSizeAvailable = product.variants.some(function (v) {
        return hasSellableStock(v) && v.options[colorIndex] === selectedColor && v.options[sizeIndex] === sizeValue;
      });
      setSwatchHidden(sizeItems[s], !isSizeAvailable);
    }

    var checkedSizeInput = sizeWrap.querySelector("input[type='radio']:checked");
    var checkedSizeItem = checkedSizeInput ? checkedSizeInput.closest(".product-form__swatch__item") : null;
    if (checkedSizeItem && checkedSizeItem.style.display === "none") {
      var fallbackSizeInput = getFirstVisibleSwatchInput(sizeItems);
      if (fallbackSizeInput && !fallbackSizeInput.checked) {
        fallbackSizeInput.checked = true;
        fallbackSizeInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  document.addEventListener("venue:variant:update", function (event) {
    var detail = event && event.detail ? event.detail : {};
    applyUSSwatchVisibility(detail.product, detail.variant, detail.sectionClass);
  });
})();